import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _EmploymentType, _RetroactiveEmployee } from "../../../../core/services/dataBean/EntityCatalogVdos";

import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../theme/Input/InputDate";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";


export const EmploymentType = () => {

    const employeetype = useDataBean(_EmploymentType);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [bonus, setBonus] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        employeetype.instance.getEmploymentTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        employeetype.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        employeetype.deleteItemVoid(employeetype.bean.IDEmploymentType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
       //console.log(entailment.bean);
       employeetype.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDEmploymentType', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'No usar Rubro Presupuestal', property: 'NotUseBudget', visible: true },
        { title: 'Cuenta de Gasto', property: 'ExpensiveAccountantIDStrName', visible: true },
        { title: 'Cuenta de Pago', property: 'PaymentAccountantIDStrName', visible: true }, 
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${employeetype.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Empleos">
            <div className="row">
                
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={employeetype.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            
                            <div className="col-md-6">
                        <label>Nombre</label>
                        <input type="text" name="Name" className="form-control" value={employeetype.bean.Name} onChange={employeetype.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Codígo</label>
                        <input type="text" name="Code" className="form-control" value={employeetype.bean.Code} onChange={employeetype.handleChange} />
                    </div>
                   
                         <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Gasto" jsonCode={employeetype.bean.ExpensiveAccountantIDStr} onChange={(e) => { employeetype.setBean({ ...employeetype.bean, "ExpensiveAccountantIDStr": e.JsonCode }) }} />
                         </div>
                         <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta de Pago" jsonCode={employeetype.bean.PaymentAccountantIDStr} onChange={(e) => { employeetype.setBean({ ...employeetype.bean, "PaymentAccountantIDStr": e.JsonCode }) }} />
                         </div>
                         <div className="col-md-6">
                         <SelectBudgetID label="Rubro Presupuestal" edit={false} tipoPresupuesto={null} jsonCode={employeetype.bean.BudgetIDStr} onChange={(e) => { employeetype.setBean({ ...employeetype.bean, "BudgetIDStr": e.JsonCode }) }} />
                         </div>
                         <div className="col-md-6">
                             <BasicSwitch label='No usar Rubro Presupuestal' estado={employeetype.bean.NotUseBudget} eventChange={(e) => { employeetype.setBean({ ...employeetype.bean, "NotUseBudget": e }) }} />
                         </div>
                         
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {employeetype.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}